export default __webpack_public_path__ + "static/media/1965.d69e1f53.png";